import i18n from "i18next";

const allJoints = [
  "knee",
  "hip",
  "foot",
  "hand",
  "elbow",
  "shoulder",
  "jaw",
  "wrist",
  "lower_leg",
  "neck",
  "lower_back",
  "upper_back",
  "fall_prevention",
  "osteoporosis",
  "pelvic_floor",
] as const;

type Joint = (typeof allJoints)[number];

interface Args {
  painLocation: Joint | "other" | string | null | undefined;
  plural?: boolean;
}

/**
 * This method will return the translated pain location
 * @param painLocation - The pain location to translate
 * @param plural (default: false) - Optional parameter to indicate if the translation should be plural
 */
export function translatePainLocation({ painLocation, plural = false }: Args): string {
  if (!painLocation) {
    return "";
  }

  const keyMap: Record<Joint | "other", string> = {
    elbow: !plural ? i18n.t("patients.pain_location.elbow_one") : i18n.t("patients.pain_location.elbow_other"),
    fall_prevention: i18n.t("patients.pain_location.fall_prevention_one"),
    foot: !plural ? i18n.t("patients.pain_location.foot_one") : i18n.t("patients.pain_location.foot_other"),
    hand: !plural ? i18n.t("patients.pain_location.hand_one") : i18n.t("patients.pain_location.hand_other"),
    hip: !plural ? i18n.t("patients.pain_location.hip_one") : i18n.t("patients.pain_location.hip_other"),
    jaw: !plural ? i18n.t("patients.pain_location.jaw_one") : i18n.t("patients.pain_location.jaw_other"),
    knee: !plural ? i18n.t("patients.pain_location.knee_one") : i18n.t("patients.pain_location.knee_other"),
    lower_back: i18n.t("patients.pain_location.lower_back_one"),
    lower_leg: !plural
      ? i18n.t("patients.pain_location.lower_leg_one")
      : i18n.t("patients.pain_location.lower_leg_other"),
    neck: i18n.t("patients.pain_location.neck_one"),
    osteoporosis: i18n.t("patients.pain_location.osteoporosis_one"),
    pelvic_floor: i18n.t("patients.pain_location.pelvic_floor_one"),
    other: !plural ? i18n.t("patients.pain_location.other_one") : i18n.t("patients.pain_location.other_other"),
    shoulder: !plural ? i18n.t("patients.pain_location.shoulder_one") : i18n.t("patients.pain_location.shoulder_other"),
    upper_back: i18n.t("patients.pain_location.upper_back_one"),
    wrist: !plural ? i18n.t("patients.pain_location.wrist_one") : i18n.t("patients.pain_location.wrist_other"),
  };

  return keyMap[painLocation as Joint] || "";
}
